// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#cloud-gradient {
  --color-stop: rgba(255, 255, 255, 0.65);
  --color-bot: rgba(243, 237, 237, 0.8);
}

#sun-gradient {
  --color-stop: rgba(236, 184, 0, 0.9);
  --color-bot: rgba(234, 121, 13, 0.9);
}

#thunder-gradient {
  --color-stop: rgba(234, 190, 13, 1);
  --color-bot: rgba(223, 248, 11, 1);
}

#snowflake-gradient {
  --color-stop: rgb(224, 224, 224);
  --color-bot: rgba(255, 255, 255);
}

#fog-gradient {
  --color-stop: rgba(243, 237, 237, 1);
  --color-bot: rgb(83, 194, 236);
}

#cloud-night-gradient {
  --color-stop: rgba(255, 255, 255, 0.65);
  --color-bot: rgba(168, 164, 164, 0.9);
}

#moon-gradient {
  --color-stop: rgb(255, 255, 255);
  --color-bot: rgba(96, 96, 96, 0.84);
}

.daniel-szulc-weather-widget {
  height: 520px;
  width: 350px;
  display: flex;
  flex-direction: column;
  margin: 0;
  position: relative;
}
.daniel-szulc-weather-widget .weather-widget {
  height: 100%;
  width: 100%;
  position: relative;
}
.daniel-szulc-weather-widget .loading-area {
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.daniel-szulc-weather-widget .weather-widget .background {
  margin: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  border-radius: 30px;
  overflow: hidden;
  background: linear-gradient(45deg, #9bf8f4, #6f7bf7);
}
.daniel-szulc-weather-widget .weather-widget .background::after {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "";
  width: 150%;
  height: 130%;
  margin: 0;
  background: linear-gradient(45deg, #9bf8f4, #6f7bf7);
  border-radius: 100%;
  float: left;
}
.daniel-szulc-weather-widget .weather-widget .content {
  position: relative;
  height: 16%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon {
  height: 37%;
}
.daniel-szulc-weather-widget .weather-widget .light-font {
  color: rgba(255, 255, 255, 0.7);
  position: relative;
  top: -0.25em;
  font-size: 80%;
}
.daniel-szulc-weather-widget .weather-widget .current-weather {
  all: inherit;
  height: 25%;
  color: rgba(255, 255, 255, 0.7);
  position: relative;
}
.daniel-szulc-weather-widget .weather-widget .current-weather .light-font {
  font-weight: 400;
}
.daniel-szulc-weather-widget .weather-widget .current-weather h1 {
  padding: 0;
}
.daniel-szulc-weather-widget .weather-widget .details {
  position: relative;
  height: 22%;
  width: 100%;
  flex-direction: column;
  margin: 0;
  display: table;
}
.daniel-szulc-weather-widget .weather-widget .details .light-font {
  font-weight: 200;
  font-size: 20px;
}
.daniel-szulc-weather-widget .weather-widget .details .detail-item {
  padding: 5px;
  height: 100%;
  width: 33.33%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget .details .detail-item div {
  vertical-align: middle;
  text-align: center;
  display: flex;
  height: 50%;
  width: 100%;
}
.daniel-szulc-weather-widget .weather-widget .details .detail-item h4 {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  font-weight: 400;
  font-size: 13px;
  width: 100%;
  margin: auto;
}
.daniel-szulc-weather-widget .weather-widget .details .detail-item h2 {
  display: inline-block;
  vertical-align: middle;
  font-size: 30px;
  text-align: center;
  width: 100%;
}
.daniel-szulc-weather-widget .weather-widget h1 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h2 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h3 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h4 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h5 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h6 {
  color: white;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget h1 {
  font-size: 55px;
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 0;
  font-weight: 900;
}
.daniel-szulc-weather-widget .weather-widget h1 span.light-font {
  display: inline-block;
  width: 0;
}
.daniel-szulc-weather-widget .weather-widget h2 {
  font-size: 30px;
  padding: 5%;
  margin-block-start: 0;
  margin-block-end: 0;
  font-weight: 900;
}
.daniel-szulc-weather-widget .weather-widget h3 {
  font-size: 23px;
  margin-block-start: 0;
  margin-block-end: 0;
  font-weight: 400;
}

.spinner {
  all: initial;
  display: block;
  margin: auto;
  position: relative;
  border: 12px solid rgba(243, 243, 243, 0.5); /* Light grey */
  border-top: 12px solid rgb(58, 54, 54); /* Blue */
  border-radius: 50%;
  width: 30%;
  padding-top: 30%;
  z-index: 1;
  float: left;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#cloud-gradient {
  --color-stop: rgba(255, 255, 255, 0.65);
  --color-bot: rgba(243, 237, 237, 0.8);
}

#sun-gradient {
  --color-stop: rgba(236, 184, 0, 0.9);
  --color-bot: rgba(234, 121, 13, 0.9);
}

#thunder-gradient {
  --color-stop: rgba(234, 190, 13, 1);
  --color-bot: rgba(223, 248, 11, 1);
}

#snowflake-gradient {
  --color-stop: rgb(224, 224, 224);
  --color-bot: rgba(255, 255, 255);
}

#fog-gradient {
  --color-stop: rgba(243, 237, 237, 1);
  --color-bot: rgb(83, 194, 236);
}

#cloud-night-gradient {
  --color-stop: rgba(255, 255, 255, 0.65);
  --color-bot: rgba(168, 164, 164, 0.9);
}

#moon-gradient {
  --color-stop: rgb(255, 255, 255);
  --color-bot: rgba(96, 96, 96, 0.84);
}

.daniel-szulc-weather-widget .weather-widget .weather-icon {
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .weather-inset {
  margin: 0;
  display: inline-block;
  position: relative;
  margin-block: auto;
  min-height: 40%;
  max-width: 90%;
  max-height: 100%;
  min-width: 80%;
  height: auto;
  width: auto;
  margin-inline: auto;
  padding-block: 5%;
  padding-inline: 10%;
  justify-content: center;
  resize: horizontal;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon svg, .daniel-szulc-weather-widget .weather-widget .weather-icon .shape {
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.15));
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .clear {
  height: 90%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .cloudy {
  all: initial;
  min-width: 60%;
  min-height: 60%;
  width: 90%;
  height: auto;
  max-height: 100%;
  max-width: 100%;
  text-align: center;
  margin: 0;
  -moz-margin-start: 0;
  -moz-margin-end: 0;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .cloudy .Sun {
  padding-left: 5%;
  padding-top: 5%;
  max-width: 35%;
  min-width: 30%;
  width: auto;
  height: 50%;
  top: 0;
  z-index: 1;
  position: absolute;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .cloudy .Cloud {
  position: relative;
  height: 100%;
  z-index: 2;
  width: auto;
  -moz-margin-start: 10%;
  -moz-margin-end: 10%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .clouds {
  all: initial;
  margin-block: auto;
  text-align: center;
  display: block;
  margin: auto;
  height: auto;
  max-width: 90%;
  -moz-margin-start: 10%;
  -moz-margin-end: 10%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall {
  all: initial;
  display: block;
  height: 100%;
  width: 100%;
  text-align: center;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall .cloudy {
  min-width: 60%;
  min-height: 60%;
  width: 90%;
  height: auto;
  margin-bottom: 0;
  max-height: 100%;
  max-width: 100%;
  margin-inline: auto;
  text-align: center;
  display: block;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall .Cloud {
  position: relative;
  height: 75%;
  z-index: 2;
  width: auto;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall .drops {
  all: revert;
  width: 100%;
  text-align: center;
  margin-inline: auto;
  display: flex;
  justify-content: center;
  margin-top: 8%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall.snow .Snowflake {
  margin: 0;
  margin-inline: 4%;
  width: 18%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall.snow .drops {
  margin-top: 5%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall.snow.rain .drops {
  margin-top: 0;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall.snow.rain .drop-shape {
  margin-top: 10%;
  width: 16%;
  margin-bottom: 2%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fall.snow.rain .Snowflake {
  margin-top: 5%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm {
  margin: auto;
  height: auto;
  max-width: 100%;
  text-align: center;
  -moz-padding-start: 5%;
  -moz-padding-end: 5%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .Cloud {
  margin-inline: auto;
  width: 90%;
  z-index: 2;
  position: relative;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .thunder {
  width: 90%;
  text-align: center;
  margin-inline: auto;
  display: flex;
  justify-content: center;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .drop-shape {
  margin: 15%;
  margin-inline: 8%;
  width: 20%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .drops {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: -8%;
  width: 80%;
  margin-inline: auto;
  margin-right: 12%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .drops .Flash {
  margin-top: -22%;
  margin-right: -10%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .thunderstorm .Flash {
  margin-top: -30%;
  -moz-padding-start: 3%;
  -moz-padding-end: 3%;
  max-width: 35%;
  min-width: 30%;
  width: auto;
  height: 40%;
  top: 0;
  z-index: 1;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fog {
  text-align: center;
  width: 100%;
  height: 100%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fog .cloud-foggy {
  overflow: hidden;
  height: 55%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fog .Cloud {
  text-align: center;
  margin-inline: auto;
  width: 65%;
  position: relative;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fog .Mist {
  padding: 6%;
  position: relative;
  display: block;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .fog .Mist svg {
  width: 75%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Mist svg {
  fill: url(#fog-gradient);
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Snowflake svg {
  fill: url(#snowflake-gradient);
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Cloud svg {
  fill: url(#cloud-gradient);
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Sun {
  height: 100%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Sun svg {
  fill: url(#sun-gradient);
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .Flash svg {
  fill: url(#thunder-gradient);
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .drop-shape {
  z-index: 1;
  width: 15%;
  text-align: center;
  position: relative;
  background-color: #00eaff;
  border-radius: 50% 0 50% 50%;
  transform: rotate(-30deg);
  float: left;
  margin-inline: 4%;
}
.daniel-szulc-weather-widget .weather-widget .weather-icon .drop-shape:before {
  content: "";
  float: left;
  padding-top: 100%;
}

.night-mode.weather-widget .background {
  background: linear-gradient(45deg, #0e0e11, #383c47);
}
.night-mode.weather-widget .background::after {
  background: linear-gradient(45deg, #0e0e11, #383c47);
}
.night-mode.weather-widget .weather-icon .Cloud svg {
  fill: url(#cloud-night-gradient);
}
.night-mode.weather-widget .weather-icon .Sun {
  height: 100%;
}
.night-mode.weather-widget .weather-icon .Sun svg {
  fill: url(#moon-gradient);
}
.night-mode.weather-widget .weather-icon .drop-shape {
  background-color: #1e8cb4;
}

.daniel-szulc-weather-widget * {
  font-family: "Lato", sans-serif;
}
.daniel-szulc-weather-widget * html {
  box-sizing: border-box;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Lato", sans-serif;
}
.daniel-szulc-weather-widget * code {
  font-family: "Lato", sans-serif;
}`, "",{"version":3,"sources":["webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/_colors.scss","webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/styles.scss","webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/_base.scss","webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/_loading-spinner.scss","webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/_weather-icons.scss","webpack://./node_modules/@daniel-szulc/react-weather-widget/dist/components/styles/_night-mode.scss"],"names":[],"mappings":"AAkBA;EACE,uCAAA;EACA,qCAAA;AChBF;;ADkBA;EACE,oCAAA;EACA,oCAAA;ACfF;;ADiBA;EACE,mCAAA;EACA,kCAAA;ACdF;;ADiBA;EACE,gCAAA;EACA,gCAAA;ACdF;;ADiBA;EACE,oCAAA;EACA,8BAAA;ACdF;;AD2BA;EACE,uCAAA;EACA,qCAAA;ACxBF;;AD0BA;EACE,gCAAA;EACA,mCAAA;ACvBF;;ACjCA;EAEE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;ADmCF;ACjCE;EAEE,YAAA;EACA,WAAA;EACA,kBAAA;ADkCJ;AC/BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;ADiCJ;AC5BI;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EAEA,oDAAA;AD8BN;AC5BM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EAEA,oDAAA;EACA,mBAAA;EACA,WAAA;AD8BR;ACxBE;EACE,kBAAA;EACA,WAAA;AD0BJ;ACvBE;EACE,WAAA;ADyBJ;ACtBE;EACE,+BF1DiB;EE2DjB,kBAAA;EAAoB,YAAA;EAAc,cAAA;AD0BtC;ACvBE;EACE,YAAA;EACA,WAAA;EACA,+BFjEiB;EEkEjB,kBAAA;ADyBJ;ACxBI;EACE,gBAAA;AD0BN;ACxBI;EACE,UAAA;AD0BN;ACtBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;ADwBJ;ACtBI;EACE,gBAAA;EACA,eAAA;ADwBN;ACrBI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ADuBN;ACtBM;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;ADwBR;ACtBM;EACE,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ADwBR;ACtBM;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;ADwBR;AClBI;EACE,YF5HO;EE6HP,kBAAA;ADoBN;ACtBI;EACE,YF5HO;EE6HP,kBAAA;ADwBN;AC1BI;EACE,YF5HO;EE6HP,kBAAA;AD4BN;AC9BI;EACE,YF5HO;EE6HP,kBAAA;ADgCN;AClCI;EACE,YF5HO;EE6HP,kBAAA;ADoCN;ACtCI;EACE,YF5HO;EE6HP,kBAAA;ADwCN;ACpCE;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;ADsCJ;ACrCU;EACJ,qBAAA;EACA,QAAA;ADuCN;ACpCE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;ADsCJ;ACnCE;EACE,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;ADqCJ;;AEpMA;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA,EAAA,eAAA;EACA,sCAAA,EAAA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;AFuMF;;AEnMA;EACE;IAAK,uBAAA;EFuML;EEtMA;IAAO,yBAAA;EFyMP;AACF;AD1MA;EACE,uCAAA;EACA,qCAAA;AC4MF;;AD1MA;EACE,oCAAA;EACA,oCAAA;AC6MF;;AD3MA;EACE,mCAAA;EACA,kCAAA;AC8MF;;AD3MA;EACE,gCAAA;EACA,gCAAA;AC8MF;;AD3MA;EACE,oCAAA;EACA,8BAAA;AC8MF;;ADjMA;EACE,uCAAA;EACA,qCAAA;ACoMF;;ADlMA;EACE,gCAAA;EACA,mCAAA;ACqMF;;AG5PA;EAEI,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AH8PJ;AG5PI;EAEE,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AH4PN;AGzPI;EACE,iDJnBG;EIoBH,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AH2PN;AGxPI;EACE,WAAA;AH0PN;AGtPE;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EAEA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AHuPJ;AGtPI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;AHwPN;AGpPI;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;AHsPN;AGjPE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AHmPJ;AGhPI;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AHkPN;AGjPM;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EAEA,cAAA;AHkPR;AG/OM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AHiPR;AG9OM;EAEE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AH+OR;AG3OQ;EACE,SAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AH6OV;AG1OQ;EACE,cAAA;AH4OV;AGxOU;EACE,aAAA;AH0OZ;AGvOU;EACE,eAAA;EACA,UAAA;EACA,iBAAA;AHyOZ;AGtOU;EACE,cAAA;AHwOZ;AGjOI;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AHmON;AGlOM;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AHoOR;AGjOM;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AHmOR;AGhOM;EACE,WAAA;EACA,iBAAA;EACA,UAAA;AHkOR;AG/NM;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;AHiOR;AG/NQ;EACE,gBAAA;EACA,kBAAA;AHiOV;AG7NM;EACE,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;AH+NR;AG1NI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AH4NN;AG1NM;EACE,gBAAA;EACA,WAAA;AH4NR;AGzNM;EACE,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AH2NR;AGxNM;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AH0NR;AGxNQ;EACE,UAAA;AH0NV;AGnNM;EACE,wBJ1OO;AC+bf;AGhNM;EACE,8BJjPa;ACmcrB;AG5MM;EACE,0BJ3PS;ACycjB;AG1MI;EACE,YAAA;AH4MN;AG1MM;EACE,wBJlQO;AC8cf;AGvMM;EACE,4BJvQW;ACgdnB;AGrMI;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBJpRQ;EIqRR,4BAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;AHuMN;AGpMI;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AHsMN;;AIzeI;EAEF,oDAAA;AJ4eF;AI3eM;EAEE,oDAAA;AJ6eR;AIteI;EACE,gCL0BiB;AC8cvB;AIreE;EACE,YAAA;AJueJ;AIteI;EACE,yBLmBU;ACqdhB;AIneE;EACE,yBLmBe;ACkdnB;;AA5fA;EAEE,+BAAA;AA8fF;AA5fA;EACE,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,kCAAA;EACA,+BAAA;AA8fF;AA3fA;EACE,+BAAA;AA6fF","sourcesContent":["//////// DEFAULT COLORS ////////\r\n\r\n\r\n$base-firs-color: #9bf8f4;\r\n$base-second-color: #6f7bf7;\r\n$background-gradient: (45deg, $base-firs-color, $base-second-color);\r\n\r\n$font-color: white;\r\n$font-second-color:  rgba($font-color, 0.7);\r\n\r\n$water-drop:  #00eaff;\r\n$shadow: drop-shadow(0 0 10px rgba(0, 0, 0, 0.15));\r\n$cloud-gradient: url(#cloud-gradient);\r\n$sun-gradient: url(#sun-gradient);\r\n$thunder-gradient: url(#thunder-gradient);\r\n$snowflake-gradient: url(#snowflake-gradient);\r\n$fog-gradient: url(#fog-gradient);\r\n\r\n#cloud-gradient{\r\n  --color-stop: rgba(255, 255, 255, 0.65);\r\n  --color-bot: rgba(243, 237, 237, 0.8);\r\n}\r\n#sun-gradient {\r\n  --color-stop: rgba(236, 184, 0, 0.9);\r\n  --color-bot: rgba(234, 121, 13, 0.9);\r\n}\r\n#thunder-gradient {\r\n  --color-stop: rgba(234, 190, 13, 1);\r\n  --color-bot: rgba(223, 248, 11, 1);\r\n}\r\n\r\n#snowflake-gradient{\r\n  --color-stop: rgb(224, 224, 224);\r\n  --color-bot: rgba(255, 255, 255);\r\n}\r\n\r\n#fog-gradient{\r\n  --color-stop: rgba(243, 237, 237, 1);\r\n  --color-bot: rgb(83, 194, 236);\r\n}\r\n\r\n//////// NIGHT COLORS ////////\r\n\r\n$moon-gradient: url(#moon-gradient);\r\n$cloud-night-gradient: url(#cloud-night-gradient);\r\n\r\n$night-base-first-color: #0e0e11;\r\n$night-base-second-color: #383c47;\r\n$night-background-gradient: (45deg, $night-base-first-color, $night-base-second-color);\r\n$night-water-drop: #1e8cb4;\r\n\r\n#cloud-night-gradient{\r\n  --color-stop: rgba(255, 255, 255,  0.65);\r\n  --color-bot: rgba(168, 164, 164, 0.9);\r\n}\r\n#moon-gradient {\r\n  --color-stop: rgb(255, 255, 255);\r\n  --color-bot: rgba(96, 96, 96, 0.84);\r\n}","\n@import 'colors';\n@import 'base';\n@import 'loading-spinner';\n@import 'weather-icons';\n@import 'night-mode';\n@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap'); //fonts\n.daniel-szulc-weather-widget * {\n\n  font-family: 'Lato', sans-serif;\n\nhtml {\n  box-sizing: border-box;\n  width: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: 'Lato', sans-serif;\n}\n\ncode {\n  font-family: 'Lato', sans-serif;\n}\n}\n","\r\n.daniel-szulc-weather-widget {\r\n\r\n  height: 520px;\r\n  width: 350px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0;\r\n  position: relative;\r\n\r\n  .weather-widget{\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n    position: relative;\r\n  }\r\n\r\n  .loading-area{\r\n    width: 100%;\r\n    height: 100%;\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  .weather-widget {\r\n\r\n    .background {\r\n      margin: 0;\r\n      position: absolute;\r\n      height: 100%;\r\n      width: 100%;\r\n      z-index: 0;\r\n      border-radius: 30px;\r\n      overflow: hidden;\r\n      background: -webkit-linear-gradient($background-gradient);\r\n      background: linear-gradient($background-gradient);\r\n\r\n      &::after {\r\n        position: absolute;\r\n        top: 90%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        content: \"\";\r\n        width: 150%;\r\n        height: 130%;\r\n        margin: 0;\r\n        background: -webkit-linear-gradient($background-gradient);\r\n        background: linear-gradient($background-gradient);\r\n        border-radius: 100%;\r\n        float: left;\r\n      }\r\n    }\r\n\r\n\r\n\r\n  .content {\r\n    position: relative;\r\n    height: 16%;\r\n  }\r\n\r\n  .weather-icon{\r\n    height:37%;\r\n  }\r\n\r\n  .light-font{\r\n    color: $font-second-color;\r\n    position: relative; top: -0.25em; font-size: 80%;\r\n  }\r\n\r\n  .current-weather{\r\n    all: inherit;\r\n    height:25%;\r\n    color: $font-second-color;\r\n    position: relative;\r\n    .light-font{\r\n      font-weight: 400;\r\n    }\r\n    h1{\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .details{\r\n    position: relative;\r\n    height: 22%;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    margin: 0;\r\n    display: table;\r\n\r\n    .light-font{\r\n      font-weight: 200;\r\n      font-size: 20px;\r\n    }\r\n\r\n    .detail-item{\r\n      padding: 5px;\r\n      height: 100%;\r\n      width: 33.33%;\r\n      display: table-cell;\r\n      vertical-align: middle;\r\n      text-align:center;\r\n      div {\r\n        vertical-align: middle;\r\n        text-align:center;\r\n        display:flex;\r\n        height: 50%;\r\n        width: 100%;\r\n      }\r\n      h4{\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        line-height: normal;\r\n        font-weight: 400;\r\n        font-size: 13px;\r\n        width: 100%;\r\n        margin: auto;\r\n      }\r\n      h2{\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-size: 30px;\r\n        text-align:center;\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  @for $index from 1 through 6 {\r\n    h#{$index}{\r\n      color: $font-color;\r\n      text-align: center;\r\n    }\r\n  }\r\n\r\n  h1{\r\n    font-size: 55px;\r\n    margin-block-start: 0;\r\n    margin-block-end: 0;\r\n    padding: 0;\r\n    font-weight: 900;\r\n    span {&.light-font{\r\n      display: inline-block;\r\n      width: 0;\r\n    }}\r\n  }\r\n  h2{\r\n    font-size: 30px;\r\n    padding: 5%;\r\n    margin-block-start: 0;\r\n    margin-block-end: 0;\r\n    font-weight: 900;\r\n  }\r\n\r\n  h3{\r\n    font-size: 23px;\r\n    margin-block-start: 0;\r\n    margin-block-end: 0;\r\n    font-weight: 400;\r\n  }\r\n  }\r\n}\r\n\r\n\r\n",".spinner {\r\n  all: initial;\r\n  display: block;\r\n  margin: auto;\r\n  position: relative;\r\n  border: 12px solid rgba(243, 243, 243, 0.5); /* Light grey */\r\n  border-top: 12px solid rgb(58, 54, 54); /* Blue */\r\n  border-radius: 50%;\r\n  width: 30%;\r\n  padding-top: 30%;\r\n  z-index: 1;\r\n  float: left;\r\n  animation: spin 2s linear infinite;\r\n\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}","@import 'colors';\r\n\r\n.daniel-szulc-weather-widget .weather-widget .weather-icon {\r\n\r\n    margin: 0;\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .weather-inset {\r\n\r\n      margin: 0;\r\n      display: inline-block;\r\n      position: relative;\r\n      margin-block: auto;\r\n      min-height: 40%;\r\n      max-width: 90%;\r\n      max-height: 100%;\r\n      min-width: 80%;\r\n      height: auto;\r\n      width: auto;\r\n      margin-inline: auto;\r\n\r\n      padding-block: 5%;\r\n      padding-inline: 10%;\r\n      justify-content: center;\r\n      resize: horizontal;\r\n    }\r\n\r\n    svg, .shape {\r\n      filter: $shadow;\r\n      max-width: 100%;\r\n      max-height: 100%;\r\n      height: auto;\r\n      width: auto;\r\n    }\r\n\r\n    .clear {\r\n      height: 90%;\r\n    }\r\n\r\n\r\n  .cloudy {\r\n    all: initial;\r\n    min-width: 60%;\r\n    min-height: 60%;\r\n    width: 90%;\r\n    height: auto;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n\r\n    text-align: center;\r\n    margin: 0;\r\n    -moz-margin-start: 0;\r\n    -moz-margin-end:0;\r\n    .Sun {\r\n      padding-left: 5%;\r\n      padding-top: 5%;\r\n      max-width: 35%;\r\n      min-width: 30%;\r\n      width: auto;\r\n      height: 50%;\r\n      top: 0;\r\n      z-index: 1;\r\n      position: absolute;\r\n\r\n    }\r\n\r\n    .Cloud {\r\n      position: relative;\r\n      height: 100%;\r\n      z-index: 2;\r\n      width: auto;\r\n      -moz-margin-start: 10%;\r\n      -moz-margin-end:10%;\r\n    }\r\n  }\r\n\r\n\r\n  .clouds{\r\n    all: initial;\r\n    margin-block: auto;\r\n    text-align: center;\r\n    display: block;\r\n    margin: auto;\r\n    height: auto;\r\n    max-width: 90%;\r\n    -moz-margin-start: 10%;\r\n    -moz-margin-end:10%;\r\n  }\r\n\r\n    .fall {\r\n      all: initial;\r\n      display: block;\r\n      height: 100%;\r\n      width: 100%;\r\n      text-align: center;\r\n      .cloudy{\r\n        min-width: 60%;\r\n        min-height: 60%;\r\n        width: 90%;\r\n        height: auto;\r\n        margin-bottom: 0;\r\n        max-height: 100%;\r\n        max-width: 100%;\r\n        margin-inline: auto;\r\n        text-align: center;\r\n\r\n        display: block;\r\n      }\r\n\r\n      .Cloud {\r\n        position: relative;\r\n        height: 75%;\r\n        z-index: 2;\r\n        width: auto;\r\n      }\r\n\r\n      .drops {\r\n\r\n        all: revert;\r\n        width: 100%;\r\n        text-align: center;\r\n        margin-inline: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n        margin-top: 8%;\r\n      }\r\n\r\n      &.snow {\r\n        .Snowflake {\r\n          margin: 0;\r\n          margin-inline: 4%;\r\n          width: 18%;\r\n          text-align: center;\r\n          display: flex;\r\n          justify-content: center;\r\n        }\r\n\r\n        .drops {\r\n          margin-top: 5%;\r\n        }\r\n\r\n        &.rain {\r\n          .drops {\r\n            margin-top: 0;\r\n          }\r\n\r\n          .drop-shape {\r\n            margin-top: 10%;\r\n            width: 16%;\r\n            margin-bottom: 2%;\r\n          }\r\n\r\n          .Snowflake {\r\n            margin-top: 5%;\r\n\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .thunderstorm {\r\n      margin: auto;\r\n      height: auto;\r\n      max-width: 100%;\r\n      text-align: center;\r\n      -moz-padding-start: 5%;\r\n      -moz-padding-end: 5%;\r\n      .Cloud {\r\n        margin-inline: auto;\r\n        width: 90%;\r\n        z-index: 2;\r\n        position: relative;\r\n      }\r\n\r\n      .thunder{\r\n        width: 90%;\r\n        text-align: center;\r\n        margin-inline: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n      }\r\n\r\n      .drop-shape {\r\n        margin: 15%;\r\n        margin-inline: 8%;\r\n        width: 20%;\r\n      }\r\n\r\n      .drops {\r\n        text-align: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        margin-top: -8%;\r\n        width: 80%;\r\n        margin-inline: auto;\r\n        margin-right: 12%;\r\n\r\n        .Flash {\r\n          margin-top: -22%;\r\n          margin-right: -10%;\r\n        }\r\n      }\r\n\r\n      .Flash {\r\n        margin-top: -30%;\r\n        -moz-padding-start: 3%;\r\n        -moz-padding-end: 3%;\r\n        max-width: 35%;\r\n        min-width: 30%;\r\n        width: auto;\r\n        height: 40%;\r\n        top: 0;\r\n        z-index: 1;\r\n      }\r\n\r\n    }\r\n\r\n    .fog {\r\n      text-align: center;\r\n      width: 100%;\r\n      height: 100%;\r\n\r\n      .cloud-foggy {\r\n        overflow: hidden;\r\n        height: 55%;\r\n      }\r\n\r\n      .Cloud {\r\n        text-align: center;\r\n        margin-inline: auto;\r\n        width: 65%;\r\n        position: relative;\r\n      }\r\n\r\n      .Mist {\r\n        padding: 6%;\r\n        position: relative;\r\n        display: block;\r\n\r\n        svg {\r\n          width: 75%;\r\n        }\r\n\r\n      }\r\n    }\r\n\r\n    .Mist {\r\n      svg {\r\n        fill: $fog-gradient;\r\n      }\r\n    }\r\n\r\n    .Snowflake {\r\n      svg {\r\n        fill: $snowflake-gradient;\r\n      }\r\n    }\r\n\r\n    .Cloud {\r\n\r\n      svg {\r\n        fill: $cloud-gradient;\r\n      }\r\n    }\r\n\r\n    .Sun {\r\n      height: 100%;\r\n\r\n      svg {\r\n        fill: $sun-gradient;\r\n      }\r\n    }\r\n\r\n    .Flash {\r\n      svg {\r\n        fill: $thunder-gradient;\r\n      }\r\n    }\r\n\r\n    .drop-shape {\r\n      z-index: 1;\r\n      width: 15%;\r\n      text-align: center;\r\n      position: relative;\r\n      background-color: $water-drop;\r\n      border-radius: 50% 0 50% 50%;\r\n      transform: rotate(-30deg);\r\n      float: left;\r\n      margin-inline: 4%;\r\n    }\r\n\r\n    .drop-shape:before {\r\n      content: \"\";\r\n      float: left;\r\n      padding-top: 100%;\r\n    }\r\n\r\n  }\r\n","\r\n\r\n.night-mode{\r\n\r\n  &.weather-widget{\r\n    .background{\r\n  background: -webkit-linear-gradient($night-background-gradient);\r\n  background: linear-gradient($night-background-gradient);\r\n      &::after{\r\n        background: -webkit-linear-gradient($night-background-gradient);\r\n        background: linear-gradient($night-background-gradient);\r\n      }\r\n\r\n}\r\n    .weather-icon{\r\n\r\n  .Cloud{\r\n    svg{\r\n      fill: $cloud-night-gradient\r\n    }\r\n  }\r\n  .Sun{\r\n    height: 100%;\r\n    svg{\r\n      fill: $moon-gradient;\r\n    }\r\n  }\r\n\r\n\r\n  .drop-shape{\r\n    background-color: $night-water-drop;\r\n  }\r\n}\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
